var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpvotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8 4.99995L5 0.199951L0.199997 4.99995H2.6V9.79995H7.4V4.99995H9.8Z",
    fill: "#2BE7A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpvotes);
export default __webpack_public_path__ + "static/media/Upvotes.5e57028da123c3d9dd3312d51a2e7cdc.svg";
export { ForwardRef as ReactComponent };